

let Cleaner = {}



Cleaner.Convert = (data) => {
        try {
            return data.map((obj) => { return { value: obj.id, label: obj.name } }) 
        } catch {
            return [[{ value: 1, label: 'Yes' }, { value: 2, label: "No" }]]
        }
        
}

Cleaner.ConverUser = (data) => {
    try {
        return data.map((obj) => { return { value: obj.id, label: (obj.firstName + " " + obj.lastName) } })
    } catch {
        return [{ value: 0, name: "N/A" }]
    }
}

export default Cleaner
